import { Button, Checkbox, Col, DatePicker, Form, Input, InputNumber, Pagination, Radio, Row, Select, Space, Table, Tabs } from 'antd';
import React, { useState } from 'react';
import { Link, useLoaderData, useOutletContext } from 'react-router-dom';
import RowEditableTable from '../../../globalComponents/RowEditableTable';
import useReOrderingAPI from '../../apis/reorderingAPI';

const columns = [
  {
    title: 'Product',
    dataIndex: 'product_id',
    key: 'product_id',
    editable: true,
    width: '15%',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white'
  },
  {
    title: 'Location',
    dataIndex: 'location_id',
    key: 'location_id',
    editable: true,
    width: '15%',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white'
  },
  {
    title: 'On Hand',
    dataIndex: 'on_hand_quantity',
    key: 'on_hand_quantity',
    editable: true,
    width: '10%',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white'
  },
  {
    title: 'Forecast',
    dataIndex: 'forecast_quantity',
    key: 'forecast_quantity',
    editable: true,
    width: '10%',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white'
  },
  {
    title: 'Preferred Route',
    dataIndex: 'preferred_route_id',
    key: 'preferred_route_id',
    editable: true,
    width: '15%',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white'
  },
  {
    title: 'Vendor',
    dataIndex: 'vendor_id',
    key: 'vendor_id',
    editable: true,
    width: '15%',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white'
  },
  {
    title: 'Min Quantity',
    dataIndex: 'min_quantity',
    key: 'min_quantity',
    editable: true,
    width: '10%',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white'
  },
  
  {
    title: 'Max Quantity',
    dataIndex: 'max_quantity',
    key: 'max_quantity',
    editable: true,
    width: '10%',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white'
  },
  {
    title: 'To Order',
    dataIndex: 'to_order_quantity',
    key: 'to_order_quantity',
    editable: true,
    width: '10%',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white'
  },
  // {
  //   title: 'Trigger',
  //   dataIndex: 'trigger',
  //   key: 'trigger',
  //   editable: true,
  //   width: '10%',
  //   className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white'
  // },
  {
    title: '',
    key: 'operation',
    // editable: true,
    fixed: 'right',
    // width: 100,
    className: 'whitespace-nowrap font-medium text-dark-600 dark:text-white',
  }
]


const preferredRoute = [
  {label: 'Buy', value: 'buy'},
  {label: 'Replenish On Order', value: 'mto'},
]

// const triggers = [
//   {label: 'Auto', value: 'auto'},
//   {label: 'Manual', value: 'manual'},
// ]

const Replenishments = () => {
  const {replenishments, products, locations} = useLoaderData();
  const [editingKey, setEditingKey] = useState('');
  const [replenishmentRules, setReplenishmentRules] = useState(replenishments);
  const { success, error } = useOutletContext();
  const { create } = useReOrderingAPI();


  const onClick = (record) => {
    let data = {...record};
    create(record, success)  
    console.log(data);
  }


  const addLine = () => {
    let replenishmentRules_ = [...replenishmentRules];
    let obj = {
      key: replenishmentRules.length + 1,
      location_id: '',
      product_id: '',
      on_hand_quantity: 0,
      forecast_quantity: 0,
      min_quantity: 0,
      max_quantity: 0,
      to_order_quantity: 0,
      preferred_route_id: '',
      vendor_id: '',
    };
    replenishmentRules_.push(obj);
    setReplenishmentRules(replenishmentRules_);
    setEditingKey(replenishmentRules.length + 1);
  }

  return (
    <div>
      <div className='flex justify-between mx-4'>
        <h3 className='font-bold'>Replenishments</h3>
        <div className=' bg-white dark:bg-gray-900'>
          {/* <Input addonBefore={<MdFilterAlt />}  defaultValue="mysite" /> */}

          <Select
            mode='multiple'
            size={'middle'}
            placeholder='Filter'
            // defaultValue={['a10', 'c12']}
            // onChange={handleChange}
            className='w-96'
            options={[]}
          />
        </div>
      </div>
      <div className='columns-2 mx-4 my-2'>
        <div className='column'>
          <Button className='' size={'sm'} onClick={addLine}>New</Button>
        </div>
        <div className='dark:bg-gray-900 column'>
          <div className='flex justify-end'>
            <Pagination  total={50} />
          </div>
        </div>
      </div>
      <RowEditableTable
        dataSource={replenishmentRules}
        setDataSource={setReplenishmentRules}
        columns={columns}
        editingKey={editingKey}
        setEditingKey={setEditingKey}
        options={{products: products, users: [], locations: locations,}}
        routes = {preferredRoute}
        triggers = {[]}
        onClick={onClick}
      />
    
    </div>
  )
}

export default Replenishments;